import { ITimeZoneDictionaryApi } from '@/types';

export class TimeZoneItem {
    id: number;
    name: string;
    code: string;

    constructor(data: ITimeZoneDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.code = data.code;
    }
}
